import React from 'react';
import CustomCard from '../../Components/CustomCard';
import './Dashboard.css';
import Navbar from '../../Components/Navbar';
// import grantImage from '../../Assets/img12.jpg';
// import budgetImage from '../../Assets/img13.jpg';
// import progressImage from '../../Assets/img14.jpg';
// import AgreementImage from '../../Assets/img16.jpg';
// import CriteriaImage from '../../Assets/img17.jpg';
// import progressImage1 from '../../Assets/img7.png';
// import FinalReport from '../../Assets/img8.png';
// import ApproveBudget from '../../Assets/img9.png';
// import SubmittedGrant from '../../Assets/img10.jpg';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../Assets/Loginbackground.png';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import MoneyIcon from '@mui/icons-material/Money';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import AttachEmailRoundedIcon from '@mui/icons-material/AttachEmailRounded';
import DescriptionIcon from '@mui/icons-material/Description';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import ReorderRoundedIcon from '@mui/icons-material/ReorderRounded';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PasswordIcon from '@mui/icons-material/Password';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';


export default function Dashboard() {
  
  const userRole = localStorage.getItem('userRole');
  const navigate = useNavigate();

  const renderCards = () => {
    switch (userRole) {
      case 'urc': // Director
        return (
          <>
            <CustomCard 
              title="View Applications" 
              linkTo="/viewapplicationd"
              icon={<MenuBookIcon/>} 
              //imageSrc={grantImage} 
            />
            <CustomCard 
              title="View Criteria" 
              linkTo="/reviewcriteriad" 
              icon={<ChecklistRoundedIcon/>}
              //imageSrc={CriteriaImage} 
            />
               <CustomCard 
              title="Order Applications and View" 
              linkTo="/orderapplication" 
              icon={<ReorderRoundedIcon/>}
              //imageSrc={SubmittedGrant} 
              //className="transparent-image" 
            />
            <CustomCard 
              title="Request Progress Report" 
              linkTo="/progressreportd"  
              //imageSrc={progressImage}
              icon={<AssessmentRoundedIcon/>}
            />
            <CustomCard 
              title="Approve Budget Revision" 
              linkTo="/approvebudgetd"
              icon={<MoneyIcon/>} 
              //imageSrc={budgetImage} 

            />
            <CustomCard 
              title="Request Approvals" 
              linkTo="/requestapproval" 
              icon={<CheckCircleRoundedIcon/>}
              //imageSrc={budgetImage} 
            />   
            <CustomCard 
              title="Send Reviewers" 
              linkTo="/sendreviewers" 
              icon={<AttachEmailRoundedIcon/>}
              //imageSrc={budgetImage} 
            />  
            
             <CustomCard 
              title="Shortlisted Applications (Approved Applications)"   
              linkTo="/shortlistedapplicationd" 
              icon={<AssignmentRoundedIcon/>}
              //imageSrc={FinalReport} 
              //className="transparent-image" 
            /> 
            <CustomCard 
              title="Request Agreements" 
              linkTo="/requestagreement" 
              icon={<DescriptionIcon/>} 
              //imageSrc={AgreementImage} 
            />  
             <CustomCard 
              title="Add Reviewer Documents" 
              linkTo="/reviewerdocument" 
              icon={<UploadFileIcon/>} 
              //imageSrc={AgreementImage} 
            />  

             <CustomCard 
              title="Application Dates"    
              linkTo="/applicationdates" 
              icon={<CalendarMonthIcon/>}
              //imageSrc={FinalReport} 
              //className="transparent-image" 
            />   
              <CustomCard 
              title="Create An Account"    
              linkTo="/newaccount" 
              icon={<ManageAccountsIcon/>}
              //imageSrc={FinalReport} 
              //className="transparent-image" 
            /> 
             
            
             <CustomCard 
              title="Change Password" 
              linkTo="/changepassword" 
              icon={<PasswordIcon/>}
             // imageSrc={SubmittedGrant} 
            />    
          </>
        );
      case 'Applicant':
        return (
          <>
              <CustomCard 
              title="Apply New Grant" 
              linkTo="/grant"
              icon={<LibraryBooksIcon />}  // Render icon as a JSX element
              // imageSrc={grantImage} 
            />
            <CustomCard 
              title="Apply Budget Revision" 
              linkTo="/budget" 
              icon={<MoneyIcon/>}
              // imageSrc={budgetImage} 
            />
            <CustomCard 
              title="Submit Progress Report" 
              linkTo="/progressreport" 
              icon={<AssessmentIcon/>}
              // imageSrc={progressImage} 
            />
            <CustomCard 
              title="View Applied Grants" 
              linkTo="/submittedgrant" 
              icon={<MenuBookIcon/>}
             // imageSrc={SubmittedGrant} 
            />
             <CustomCard 
              title="Change Password" 
              linkTo="/changepassword" 
              icon={<PasswordIcon/>}
             // imageSrc={SubmittedGrant} 
            />
            
          </>
        );
      case 'Admin': // Secretary
        return (
          <>
            <CustomCard 
              title="View Applications" 
              linkTo="/viewapplication" 
              icon={<MenuBookIcon/>} 
              //imageSrc={grantImage}
              //className="transparent-image"  
            />
            <CustomCard 
              title="Customize Review Criteria (Criteria, Weight, Marks)"  
              linkTo="/reviewcriteria" 
              icon={<ChecklistRoundedIcon/>}
              //imageSrc={CriteriaImage} 
              //className="transparent-image" 
            />
            <CustomCard 
              title="Order Applications and View" 
              linkTo="/orderapplication" 
              icon={<ReorderRoundedIcon/>}
              //imageSrc={SubmittedGrant} 
              //className="transparent-image" 
            />
            <CustomCard 
              title="Request Progress Report"  
              linkTo="/requestreport" 
              icon={<AssessmentRoundedIcon/>}
              //imageSrc={FinalReport} 
              //className="transparent-image" 
            />
            <CustomCard 
              title="Approve Budget Revision"  
              linkTo="/approvebudget" 
              icon={<MoneyIcon/>} 
              //imageSrc={budgetImage}
              //className="transparent-image"  
            />   
             <CustomCard 
              title="Request Approvals" 
              linkTo="/requestapproval" 
              icon={<CheckCircleRoundedIcon/>}
              //imageSrc={budgetImage} 
            />   
            <CustomCard 
              title="Send Reviewers" 
              linkTo="/sendreviewers" 
              icon={<AttachEmailRoundedIcon/>}
              //imageSrc={budgetImage} 
            />  
           
             <CustomCard 
              title="Shortlisted Applications (Approved Applications)"   
              linkTo="/shortlistedapplication" 
              icon={<AssignmentRoundedIcon/>}
              //imageSrc={FinalReport} 
              //className="transparent-image" 
            />
             <CustomCard 
              title="Request Agreements" 
              linkTo="/requestagreement" 
              icon={<DescriptionIcon/>} 
              //imageSrc={AgreementImage} 
            /> 
             <CustomCard 
              title="Add Reviewer Documents" 
              linkTo="/reviewerdocument" 
              icon={<UploadFileIcon/>} 
              //imageSrc={AgreementImage} 
            />  

             <CustomCard 
              title="Application Dates"    
              linkTo="/applicationdates" 
              icon={<CalendarMonthIcon/>}
              //imageSrc={FinalReport} 
              //className="transparent-image" 
            />   
             <CustomCard 
              title="Change Password" 
              linkTo="/changepassword" 
              icon={<PasswordIcon/>}
             // imageSrc={SubmittedGrant} 
            />   
              <CustomCard 
              title="Create An Account"    
              linkTo="/newaccount" 
              icon={<ManageAccountsIcon/>}
              //imageSrc={FinalReport} 
              //className="transparent-image" 
            />  
          </>
        );
      default:
        return <p>No dashboard available for your role.</p>;
    }
  };

  return (
    <div className="dashboard-background" style={{ backgroundImage: `url(${backgroundImage})` }}> {/* Add this wrapper */}
      <Navbar />
      <div className="dashboard-container">
        {renderCards()}
      </div>
    </div>
  );
}

